// @ts-nocheck
// W13f: AntD Table -> Mantine Table + fix mutacao prop frozen (RTK freezing impede
// element.value = <div>...</div>; agora cria shallow copy).
import { Table } from "@mantine/core";

function buildRows(fieldItems, onActionRender) {
  if (!fieldItems) return [];
  const rows = [];
  let nextElement = null;

  fieldItems.forEach((element) => {
    // Shallow copy — RTK freezes objects in dev; mutating produces "Cannot assign
    // to read only property" TypeError.
    let item = element;
    if (nextElement) {
      item = { ...element, value: (<div>{nextElement} {element.value}</div>) };
      nextElement = null;
    }

    if (element.action) {
      nextElement = onActionRender ? onActionRender(element.action, element.value) : null;
      return;
    }

    rows.push(item);
  });

  return rows;
}

export default function TableView({ fieldItems, rowKey, onActionRender }) {
  const rows = buildRows(fieldItems, onActionRender);

  return (
    <Table withRowBorders={false} fz="xs">
      <Table.Tbody>
        {rows.map((item, i) => (
          <Table.Tr key={(rowKey && item?.[rowKey]) ?? i}>
            <Table.Td className="col-text" style={{ width: 220 }}>
              <strong>{item.label}</strong>
            </Table.Td>
            <Table.Td className="col-value" style={{ wordBreak: "break-word" }}>
              <span>{item.value}</span>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
